import { styled, Tooltip, Typography } from '@mui/material';
import StatusBadge from 'components/new/StatusBadge';
import {
  OnboardingStep,
  OnboardingStepStatus as OnboardingStepStatusType,
} from 'further-types/lp/onboarding';

const EmptyStatus = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(0, theme.spacingSizes.xs),
}));

const tooltipTitle = (requiresApproval: boolean) => ({
  [OnboardingStepStatusType.Completed]: requiresApproval
    ? 'This step has been completed and approved.'
    : 'This step has been completed.',
  [OnboardingStepStatusType.InReview]: 'This step requires your review.',
  [OnboardingStepStatusType.Requested]:
    'This step is pending investor completion.',
  [OnboardingStepStatusType.MoreInformationRequested]:
    'Awaiting additional information ',
  [OnboardingStepStatusType.StartedByInvestor]:
    'This step is pending investor completion.',
});

type Props = {
  steps: Array<{
    step: OnboardingStep;
    status: OnboardingStepStatusType | null;
    requiresApproval: boolean;
  }>;
  currentStep: OnboardingStep;
  forceStatus?: OnboardingStepStatusType;
};

const OnboardingStepStatus: React.FC<Props> = ({
  steps,
  currentStep,
  forceStatus,
}) => {
  const step = steps.find((step) => step.step === currentStep);
  const status = forceStatus ?? step?.status;

  if (!step || !status || status === OnboardingStepStatusType.Disabled)
    return (
      <Tooltip title="The investor has not been requested to complete this step.">
        <EmptyStatus variant="h6" color="grey.500">
          --
        </EmptyStatus>
      </Tooltip>
    );

  const color =
    status === OnboardingStepStatusType.Completed
      ? 'success'
      : status === OnboardingStepStatusType.InReview
      ? 'warning'
      : 'error';

  const tooltipText =
    status === OnboardingStepStatusType.Completed &&
    step.step === OnboardingStep.DataRoomView
      ? 'Data room access has been granted.'
      : tooltipTitle(step.requiresApproval)[status];

  return (
    <Tooltip placement="top" title={tooltipText}>
      <span>
        <StatusBadge color={color} />
      </span>
    </Tooltip>
  );
};

export default OnboardingStepStatus;
